import React from "react";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import logoIcon from "../../../assets/images/logoIcon.png";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import TraitChart from "./Charts/TraitChart";
import ActiveUsers from "./Charts/ActiveUsers";
import SleepChart from "./Charts/SleepChart";
import MoodChart from "./Charts/MoodChart";
import { GameIcon, GroupsIcon } from "../../../SvgIconsData";
import { FaUser, FaUsers } from "react-icons/fa";
import Statistics from "./Statistics";
import smile from "../../../assets/images/smile.png";
import Groups from "../GroupUser/Groups";
import User from "../GroupUser/User";
import teamdashboardimg from "../../../assets/images/teamdashboardimg.svg";

const TeamDashboard = () => {
  return (
    <>
      <div className="container-fluid p-4">
        <Tab.Container id="left-tabs-example" defaultActiveKey="dashboards">
          <div className="row">
            <div className="col-md-7">
              <Nav variant="pills">
                <Nav.Item>
                  <Nav.Link eventKey="dashboards">Dashboards</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="groups">Groups</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="users">Users</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <div className="col-md-5">
              <ul className="FilterDataRange">
                <li>D</li>
                <li className="active">W</li>
                <li>M</li>
                <li>6M</li>
                <li>Y</li>
              </ul>
            </div>
          </div>
          <Tab.Content>
            <Tab.Pane eventKey="dashboards">
              <div className="insights pt-4">
                <div className="row">
                  <div className="col-md-8">
                    <div className="card bg-light-blue position-relative mb-4">
                      <div className="card-body">
                        <div className="introcard d-flex gap-3 align-items-center">
                          <div className="logo">
                            <img src={logoIcon} alt="" />
                          </div>
                          <div>
                            <h5 className="mb-1">Simulanis Solution Pvt. Sol.</h5>
                            <p className="font-xs mb-0 color-light-blue">
                              Simulanis Solution Pvt. Sol
                            </p>
                          </div>
                        </div>
                      </div>
                      <img
                        className="dashimg"
                        style={{ width: "220px" }}
                        src={teamdashboardimg}
                        alt=""
                      />
                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="card h-100">
                          <div className="card-body">
                            <h6>
                              Traits Chart{" "}
                              <span className="font-xss color-light">
                                Track your most play traits
                              </span>
                            </h6>
                            <div className="icons gap-2">
                              <SportsEsportsOutlinedIcon />{" "}
                              <h4 className="mb-0">
                                255 <span className="font-xss color-light">In Week</span>
                              </h4>
                            </div>
                            <TraitChart />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card h-100">
                          <div className="card-body">
                            <h6>
                              Active Users Count{" "}
                              <span className="font-xss color-light">Track your user easily</span>
                            </h6>
                            <ActiveUsers />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="card">
                          <div className="card-body">
                            <h6>
                              Mood Chart{" "}
                              <span className="font-xss color-light">Track your mood easily</span>
                            </h6>
                            <div className="d-flex gap-2">
                              <img src={smile} style={{ width: "25px" }} alt="" />{" "}
                              <h5 className="mb-0">
                                255 <span className="font-xss color-light">In Week</span>
                              </h5>
                            </div>
                            <div className="row align-items-center justify-content-between">
                              <div className="col-md-7">{/* <MoodChart /> */}</div>
                              <div className="col-md-5 text-md-end">
                                {/* <p className='font-xss'>Hours 0-3 <strong>150</strong></p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card">
                          <div className="card-body">
                            <h6>
                              Sleep Chart{" "}
                              <span className="font-xss color-light">Track your user easily</span>
                            </h6>
                            <div className="row align-items-center justify-content-between">
                              <div className="col-md-7">
                                <SleepChart />
                              </div>
                              <div className="col-md-5 text-md-end">
                                <p className="font-xss">
                                  Hours 0-3 <strong>150</strong>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card position-relative overflow-hidden bg-light-blue1">
                      <div className="card-body">
                        <h6 className="mb-0">Traits</h6>
                        <p className="mb-2 color-light-blue">Your Assign traits</p>
                        <h4 className="mb-0">
                          <strong>04</strong>
                        </h4>
                      </div>
                      <div className="gameiconrightside">
                        <GameIcon />
                      </div>
                    </div>

                    <h6 className="pt-4">Statistics</h6>
                    <div className="row pb-4">
                      <div className="col-md-6">
                        <div className="card">
                          <div className="card-body">
                            <h4 className="mb-0 statsticsicon">
                              {" "}
                              <span>
                                <GroupsIcon />
                              </span>{" "}
                              155
                            </h4>
                            <p className="mb-0 font-xs">Groups</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="card">
                          <div className="card-body">
                            <h4 className="mb-0 statsticsicon">
                              {" "}
                              <span>
                                <FaUser style={{ color: "green", background: "#d2fbd2" }} />
                              </span>{" "}
                              155
                            </h4>
                            <p className="mb-0 font-xs">Users</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Statistics />
                  </div>
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="groups">
              <Groups />
            </Tab.Pane>
            <Tab.Pane eventKey="users">
              <User />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
};

export default TeamDashboard;
